export { default, SKELETON_SURFACE } from './Skeleton';
